<template>
    <div>
        <div>
            <div style="float:left;width:500px;text-align:left;">
                <p style="font-size:18px;font-weight:bold;">下级评估进度：</p>
                <span>工作动机重要性及满意度评估：
                    <el-progress :text-inside="true" :stroke-width="20" :percentage="percentages[0]" :color="customColorMethod" style="margin-top:10px;width:90%;"></el-progress></span>
                <br><span>激励资源评估：
                    <el-progress :text-inside="true" :stroke-width="20" :percentage="percentages[1]" :color="customColorMethod" style="margin-top:10px;width:90%;"></el-progress></span>
            </div>
            <div style="float:left;width:500px;text-align:left;margin-bottom:30px;">
                <p style="font-size:18px;font-weight:bold;">上级评估进度：</p>
                <span>下属离职倾向识别：
                    <el-progress :text-inside="true" :stroke-width="20" :percentage="percentages[2]" :color="customColorMethod" style="margin-top:10px;width:90%;"></el-progress>
                <br><span>工作动机重要性及满意度评估：
                    <el-progress :text-inside="true" :stroke-width="20" :percentage="percentages[3]" :color="customColorMethod" style="margin-top:10px;width:90%;"></el-progress></span>
                <br><span>激励资源评估：
                    <el-progress :text-inside="true" :stroke-width="20" :percentage="percentages[4]" :color="customColorMethod" style="margin-top:10px;width:90%;"></el-progress></span>
            </div>
        </div>
        <div style="width:100%;height:40px;margin-bottom:10px;clear:both;">
            <div class="top_buttons" style="float:left;">
                <el-button icon="el-icon-download" type="primary" @click="export_progress">导出进展</el-button>
                <el-button icon="el-icon-refresh" type="primary" @click="refresh_progress">刷新进展</el-button>
                <!-- <el-button icon="el-icon-message" type="warning" @click="open_dialog">邮件跟催</el-button> -->
            </div>
            <div class="search" style="float:right;">
                <el-form :inline="true" :model="formInline" @submit.native.prevent>
                <el-form-item>
                <el-input
                placeholder="请输入搜索信息"
                v-model="formInline.search_info"
                @keyup.native.enter="search"
                clearable>
                </el-input>
                </el-form-item>
                <el-form-item>
                <el-button icon="el-icon-search" type="primary" @click="search">搜索</el-button>
                </el-form-item>
                </el-form>
            </div>
        </div>
        <div style="width:100%;margin-bottom:10px;margin-top:15px;text-align:left;">
            <span style="font-weight:bold;color:#303133;">数据筛选：</span>
            <el-select v-model="motivation_ques_selected" placeholder="工作动机重要性及满意度评估" style="width:250px;margin-left:10px;" clearable @change="ques_filter">
                <el-option label="未开始(上级)" value="未开始(上级)"></el-option>
                <el-option label="未开始(下级)" value="未开始(下级)"></el-option>
                <el-option label="进行中(上级)" value="进行中(上级)"></el-option>
                <el-option label="进行中(下级)" value="进行中(下级)"></el-option>
                <el-option label="已提交(上级)" value="已提交(上级)"></el-option>
                <el-option label="已提交(下级)" value="已提交(下级)"></el-option>
            </el-select>
            <el-select v-model="resource_ques_selected" placeholder="激励资源评估" style="width:170px;margin-left:10px;" clearable @change="ques_filter">
                <el-option label="未开始(上级)" value="未开始(上级)"></el-option>
                <el-option label="未开始(下级)" value="未开始(下级)"></el-option>
                <el-option label="进行中(上级)" value="进行中(上级)"></el-option>
                <el-option label="进行中(下级)" value="进行中(下级)"></el-option>
                <el-option label="已提交(上级)" value="已提交(上级)"></el-option>
                <el-option label="已提交(下级)" value="已提交(下级)"></el-option>
            </el-select>
            <el-select v-model="behavior_ques_selected" placeholder="下属离职倾向识别" style="width:170px;margin-left:10px;" clearable @change="ques_filter">
                <el-option label="未开始" value="未开始"></el-option>
                <el-option label="进行中" value="未提交"></el-option>
                <el-option label="已提交" value="已提交"></el-option>
            </el-select>
            <!-- <el-select v-model="mail_send_status" placeholder="邮件跟催结果" style="width:170px;margin-left:10px;" clearable @change="ques_filter">
                <el-option label="失败" value="失败"></el-option>
            </el-select> -->
        </div>
        <!-- <div style="margin-bottom:10px;">
            <el-alert
                :title="tips"
                type="success"
                show-icon>
            </el-alert>
        </div> -->
        <el-table
        :data="rc_progress"
        style="width: 100%">
            <!-- <el-table-column prop="id" label="序号" min-width="5%"></el-table-column> -->
            <el-table-column type="index"></el-table-column>
            <el-table-column prop="real_name" label="评估人" min-width="10%">
                <template slot-scope="scope">
                    <div v-if="scope.row.is_superior=='是'">
                        <span>{{ scope.row.real_name }}</span><span style="color:#F56C6C;font-weight:bold;">(上级)</span>
                    </div>
                    <div v-else>{{ scope.row.real_name }}</div>
                </template>
            </el-table-column>
            <el-table-column prop="email" label="邮箱" min-width="16%"></el-table-column>
            <el-table-column prop="ques_a_status" label="工作动机重要性及满意度评估" min-width="20%">
                <el-table-column prop="ques_status" label="评估上级" min-width="10%">
                    <template slot-scope="scope">
                        <div v-if="scope.row.ques_status=='未开始'" class="not_start">{{ scope.row.ques_status }}</div>
                        <div v-else-if="scope.row.ques_status=='进行中'" class="non_finished_status">{{ scope.row.ques_status }}</div>
                        <div v-else-if="scope.row.ques_status=='已提交'" class="finished_status">{{ scope.row.ques_status }}</div>
                        <div v-else class="not_involved">{{ scope.row.ques_status }}</div>
                    </template>
                </el-table-column>
                <el-table-column prop="superior_ques_status" label="评估下级" min-width="10%">
                    <template slot-scope="scope">
                        <div v-if="scope.row.superior_ques_status=='未开始'" class="not_start">{{ scope.row.superior_ques_status }}</div>
                        <div v-else-if="scope.row.superior_ques_status=='进行中'" class="non_finished_status">{{ scope.row.superior_ques_status }}</div>
                        <div v-else-if="scope.row.superior_ques_status=='已提交'" class="finished_status">{{ scope.row.superior_ques_status }}</div>
                        <div v-else class="not_involved">{{ scope.row.superior_ques_status }}</div>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column prop="ques_b_status" label="激励资源评估" min-width="20%">
                <el-table-column prop="resource_status" label="评估上级" min-width="10%">
                    <template slot-scope="scope">
                        <div v-if="scope.row.resource_status=='未开始'" class="not_start">{{ scope.row.resource_status }}</div>
                        <div v-else-if="scope.row.resource_status=='进行中'" class="non_finished_status">{{ scope.row.resource_status }}</div>
                        <div v-else-if="scope.row.resource_status=='已提交'" class="finished_status">{{ scope.row.resource_status }}</div>
                        <div v-else class="not_involved">{{ scope.row.resource_status }}</div>
                    </template>
                </el-table-column>
                <el-table-column prop="superior_resource_status" label="评估本人" min-width="10%">
                    <template slot-scope="scope">
                        <div v-if="scope.row.superior_resource_status=='未开始'" class="not_start">{{ scope.row.superior_resource_status }}</div>
                        <div v-else-if="scope.row.superior_resource_status=='进行中'" class="non_finished_status">{{ scope.row.superior_resource_status }}</div>
                        <div v-else-if="scope.row.superior_resource_status=='已提交'" class="finished_status">{{ scope.row.superior_resource_status }}</div>
                        <div v-else class="not_involved">{{ scope.row.superior_resource_status }}</div>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column prop="ques_c_status" label="下属离职倾向识别" min-width="16%">
                <el-table-column prop="behavior_status" label="评估下级" min-width="16%">
                    <template slot-scope="scope">
                        <div v-if="scope.row.behavior_status=='未开始'" class="not_start">{{ scope.row.behavior_status }}</div>
                        <div v-else-if="scope.row.behavior_status=='进行中'" class="non_finished_status">{{ scope.row.behavior_status }}</div>
                        <div v-else-if="scope.row.behavior_status=='已提交'" class="finished_status">{{ scope.row.behavior_status }}</div>
                        <div v-else class="not_involved">{{ scope.row.behavior_status }}</div>
                    </template>
                </el-table-column>
            </el-table-column>
            <!-- <el-table-column prop="mail_send_result" label="邮件跟催结果" min-width="13%">
                <template slot="header">
                    <span>邮件跟催结果</span>
                    <el-tooltip class="item" effect="dark" content="仅展示最近一次的邮件跟催结果" placement="top-start" style="margin-left:2px;">
                        <i class="el-icon-question"></i>
                    </el-tooltip>             
                </template>
                <template slot-scope="scope">
                    <span v-if="scope.row.mail_send_result=='失败'" style="font-weight:bold;color:#F56C6C;">{{ scope.row.mail_send_result }}</span>
                </template>
            </el-table-column> -->
        </el-table>
        <el-dialog title="邮件跟催" 
        :visible.sync="dialogFormVisible" 
        width="450px" 
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        class="assessee_dialog">
            <el-form :model="form" class="dialog_form">
                <el-form-item label="调研类型" :label-width="formLabelWidth">
                    <el-select v-model="send_email_ques" placeholder="选择跟催的调研类型">
                        <el-option label="ALL" value="ALL"></el-option>
                        <el-option label="组织健康度调研" value="ques_a"></el-option>
                        <el-option label="管理痛点调研" value="ques_b"></el-option>
                        <el-option label="管理痛点献计献策" value="ques_c"></el-option>
                        <el-option label="管理痛点调研和献计献策" value="ques_d"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="开始日期" :label-width="formLabelWidth">
                    <el-date-picker 
                    v-model="form.effective_date" 
                    type="date" 
                    placeholder="请选择日期" 
                    format="yyyy 年 MM 月 dd 日" 
                    value-format="yyyy-MM-dd"></el-date-picker>
                </el-form-item>
                <el-form-item label="结束日期" :label-width="formLabelWidth">
                    <el-date-picker v-model="form.expiration_date" 
                    type="date" 
                    placeholder="请选择日期" 
                    format="yyyy 年 MM 月 dd 日" 
                    value-format="yyyy-MM-dd"></el-date-picker>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogCancel">取 消</el-button>
                <el-button type="primary" @click="send_emails">确 定</el-button>
            </div>
        </el-dialog> 
        <div style="margin-top:10px;" v-if="rc_progress.length > 0">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="pageinfo.count"
                :page-sizes="pageinfo.page_sizes"
                :page-size="pageinfo.page_size"
                layout="total, sizes, prev, pager, next"
                :total="pageinfo.count">
            </el-pagination>
        </div>
    </div>
</template>

<script>
import getdata from "@/api/getData.js";
import postdata from "@/api/postData.js";
export default {
    created() {
        // console.log('progress task id: ' + this.task_id);
        this.getProgressInfo();
    },
    mounted() {
        
    },
    data() {
        return {
            percentages: [70, 100, 9, 49, 0],
            non_finished_num: null,
            finished_num: null,
            pageinfo: {
                count: 0,
                current: 1,
                page_size: 10,
                page_sizes: [1, 10, 20, 50, 100],
            },
            formInline: {
                search_info: '',
                search_result: [],
            },
            form: {
                effective_date: '',
                expiration_date: '',
            },            
            dialogFormVisible: false,
            formLabelWidth: '90px',
            rc_progress: [],
            template_file: {
                file_name: 'Assessment_progress_RC.xlsx'
            },
            motivation_ques_selected: '',
            resource_ques_selected: '',
            behavior_ques_selected: '',
            send_email_ques: 'ALL',
            mail_send_status: '',
        };
    },
    props: ['task_id'],
    methods: {
        customColorMethod(percentage) {
            if (percentage < 10) {
                return '#F56C6C';
            } else if (percentage < 50) {
                return '#E6A23C';
            } else if (percentage < 100) {
                return '#409EFF';
            } else {
                return '#67C23A';
            }
        },
        init_form() {
            this.form.effective_date = '';
            this.form.expiration_date = '';
            this.form.send_email_ques = 'ALL';
        },
        open_dialog() {
            this.dialogFormVisible = true;
        },
        dialogCancel() {
            this.dialogFormVisible = false;
            this.init_form();
        },
        ques_filter() {
            this.getProgressInfo();
        },
        search() {
            this.getProgressInfo(this.formInline.search_info);
        },
        refresh_progress() {
            this.getProgressInfo();
            this.$message({
                message: '刷新完成！',
                type: 'success',
                duration: 1500,
            })
        },
        getProgressInfo(query_info) {
            query_info = query_info||'';
            let params;
            params = {
                query_info: query_info,
                task_id: this.task_id,
                start: (this.pageinfo.current - 1) * this.pageinfo.page_size,
                end: (this.pageinfo.current) * this.pageinfo.page_size,
                motivation_ques_selected: this.motivation_ques_selected,
                resource_ques_selected: this.resource_ques_selected,
                behavior_ques_selected: this.behavior_ques_selected,
            }
            getdata.getListP("getRCProgressInfo", params)
                .then(resp => {
                    if(resp.data.code == 200){
                        this.rc_progress = resp.data.data;
                        this.percentages = resp.data.percentages;
                        this.pageinfo.count = resp.data.count;
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        },
        handleSizeChange: function(size) {
            // 这里的size还有下面的currentPage都是系统自动识别到的，直接使用即可
            this.pageinfo.page_size = size;
            this.pageinfo.current = 1;
            if(this.query_info==''){
                this.getProgressInfo();
            }else{
                this.getProgressInfo(this.query_info);
            }
        },
        handleCurrentChange: function(currentPage) {
            this.pageinfo.current = currentPage;
            if(this.query_info==''){
                this.getProgressInfo();
            }else{
                this.getProgressInfo(this.query_info);
            }
        },
        export_progress_by_users() {
            // 先从后台获取公司列表
            getdata.getList("getCompanyList")
                .then(resp => {
                    if(resp.data.code == 200){
                        this.form.company_list = resp.data.data;
                        this.form.selected_company = this.form.company_list[0];
                        // 获取到公司列表后，打开导出页面
                        this.dialogFormVisible = true;
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        },
        export_progress() {
            let params;
            params = {
                task_id: this.task_id,
            }
            postdata.downloadFilesP("exportRCProgress", JSON.stringify(this.template_file), params)
              .then(resp => {
                // this.dialogFormVisible = false;
                // 将流文件通过浏览器下载，这里使用整个后台返回的response，供download函数提取data、headers等信息
                if(resp.data.type=='application/json'){
                    let that = this;    //这里要用别名替代this，因为FileReader里头可能也用到了this，两边有冲突
                    const reader  = new FileReader();  //创建一个FileReader实例
                    reader.readAsText(resp.data, 'utf-8'); //读取文件,结果用字符串形式表示
                    reader.onload=function(){   //读取完成后,**获取reader.result**
                        const msg = JSON.parse(reader.result);
                        that.$message({
                        message: msg.message,
                        type: 'error',
                        duration: 6000,
                        // showClose: true,
                        })
                    }
                }else{
                this.download(resp);
                }
              })
              .catch(err => {
                console.log(err);
              })
        },
        cancle_export() {
            this.dialogFormVisible = false;
        },
        download (res) {
            let blob = new Blob([res.data], { type: "application/vnd.ms-excel" });//type是文件类，详情可以参阅blob文件类型
            // 创建新的URL并指向File对象或者Blob对象的地址
            const blobURL = window.URL.createObjectURL(blob)
            // 创建a标签，用于跳转至下载链接
            const tempLink = document.createElement('a')
            tempLink.style.display = 'none'
            tempLink.href = blobURL
            tempLink.setAttribute('download', decodeURI(res.headers['content-disposition'].split(';')[1].split('=')[1]))
            // 兼容：某些浏览器不支持HTML5的download属性
            if (typeof tempLink.download === 'undefined') {
                tempLink.setAttribute('target', '_blank')
            }
            // 挂载a标签
            document.body.appendChild(tempLink)
            tempLink.click()
            document.body.removeChild(tempLink)
            // 释放blob URL地址
            window.URL.revokeObjectURL(blobURL)
        },
        send_emails() {
            this.dialogFormVisible = false;
            const loading = this.$loading({
                lock: true, // lock的修改符--默认是false
                text: '正在发送邮件，请稍后...', // 显示在加载图标下方的加载文案
                spinner: 'el-icon-loading', // 自定义加载图标类名
                background: 'rgba(0, 0, 0, 0.7)', // 遮罩层颜色
            })
            let params;
            params = {
                task_id: this.task_id,
                effective_date: this.form.effective_date,
                expiration_date: this.form.expiration_date,
                send_email_ques: this.form.send_email_ques,
            }
            getdata.getListP("sendJKEmails", params)
              .then((resp) => {
                if(resp.data.code == 200){
                    this.$message({
                        message: resp.data.message,
                        type: "success",
                    })
                    this.init_form();
                }else{
                    this.$message({
                        message: resp.data.message,
                        type: "error",
                        duration: 6000,
                        // showClose: true,
                    })
                    this.getProgressInfo();     // 有邮件发送失败时才更新结果
                }
                loading.close();
                })
              .catch(err => {
                console.log(err);
                loading.close();
              }) 
        },
    }
};
</script>

<style scoped>
.assessee_dialog /deep/ .el-dialog__header {
    text-align: left;
}
.assessee_dialog /deep/ .el-dialog__body {
    padding: 20px 20px 0px 20px;
}
.dialog_form /deep/ .el-input {
    /* width: 223.67px; */
    width: 250px;
}
.dialog_form /deep/ .el-form-item {
    margin-bottom: 14px;
}
.dialog_form /deep/ .el-textarea__inner {
    font-family: Avenir,Helvetica,Arial,sans-serif;
}
.dialog_form /deep/ .el-alert__title {
    font-size: 14px;
}
::v-deep .el-dialog__footer {
    text-align: center;
}
.top_buttons > .el-button {
    font-size: 16px;
    /* font-weight: bold; */
}
.search /deep/ .el-input {
    font-size: 16px;
}
.search /deep/ .el-button {
    font-size: 16px;
}
.search /deep/ .el-input__inner {
    height: 42.67px;
    line-height: 42.67px;
}
::v-deep .el-col-5 {
    width: 350px;
}
::v-deep .el-card__body {
    height: 70px;
    padding: 10px;
}
::v-deep .el-table__header {
    font-size: 16px;
}
::v-deep .el-form-item {
    margin-bottom: 0;
}
.el-table /deep/ th.el-table__cell {
    background-color: #f5f7fa;
}
.el-icon-warning {
    color: #F56C6C;
    font-size: 23px;
}
.el-icon-success {
    color: #67C23A;
    font-size: 23px;
}
.icon_area {
    float: left;
    margin-top: 20px;
    margin-left: 25px;
}
.span_area {
    text-align: left;
    margin-left: 80px;
    font-size: 18px;
    font-weight: bold;
    color: #606266;
}
.num_area_left {
    text-align: left;
    margin-left: 80px;
    margin-top: 5px;
    font-size: 33px;
    font-weight: bold;
    color: #F56C6C;
}
.num_area_right {
    text-align: left;
    margin-left: 80px;
    margin-top: 5px;
    font-size: 33px;
    font-weight: bold;
    color: #67C23A;
}
.standard_tips {
    border: none;
    text-align: left;
    color: #606266;
}
.not_start {
    font-size: 12px;
    background: #f56c6c;
    display: inline-block;
    white-space: nowrap;
    padding: 7px 15px;
    border-radius: 3px;
    line-height: 1;
    color: white;
}
.non_finished_status {
    font-size: 12px;
    background: #E6A23C;
    display: inline-block;
    white-space: nowrap;
    padding: 7px 15px;
    border-radius: 3px;
    line-height: 1;
    color: white;
}
.finished_status {
    font-size: 12px;
    background: #67C23A;
    display: inline-block;
    white-space: nowrap;
    padding: 7px 15px;
    border-radius: 3px;
    line-height: 1;
    color: white;
}
.not_involved {
    font-size: 12px;
    background: #909399;
    display: inline-block;
    white-space: nowrap;
    padding: 7px 15px;
    border-radius: 3px;
    line-height: 1;
    color: white;
}
.feedback_done {
    font-size: 12px;
    background: #409EFF;
    display: inline-block;
    white-space: nowrap;
    padding: 7px 15px;
    border-radius: 3px;
    line-height: 1;
    color: white;
}
.finished_num {
    font-weight: bold;
    font-size: 17px;
    color: #67C23A;
}
.non_finished_num {
    font-weight: bold;
    font-size: 17px;
    color: #f56c6c;
}
::v-deep .el-alert__title {
    font-size: 16px;
}
::v-deep .el-alert__content {
    text-align: left;
}
::v-deep .el-dialog__header {
    text-align: left;
}
</style>